import * as React from "react";
import { StaticImageData } from "next/image";

import { LinkButton } from "@stadium/shared/src/components/shared/button";
import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import { HERO_DEFAULTS, H_02 } from "@stadium/shared/src/helpers/plasmic/static-slices";

import styles from "./main.module.scss";

export interface H02Props {
  // Hero Content
  heading?: string;
  description?: string;

  // CTA Buttons
  primaryButtonText?: string;
  primaryButtonUrl?: string;
  secondaryButtonText?: string;
  secondaryButtonUrl?: string;

  // Hero Image
  heroImage: string | StaticImageData;
  heroImageAlt?: string;

  className?: string;
}

const H02: React.FC<Readonly<H02Props>> = ({
  heading = HERO_DEFAULTS[H_02].heading,
  description = HERO_DEFAULTS[H_02].description,
  primaryButtonText = HERO_DEFAULTS[H_02].primaryButtonText,
  primaryButtonUrl = HERO_DEFAULTS[H_02].primaryButtonUrl,
  secondaryButtonText = HERO_DEFAULTS[H_02].secondaryButtonText,
  secondaryButtonUrl = HERO_DEFAULTS[H_02].secondaryButtonUrl,
  heroImage = HERO_DEFAULTS[H_02].heroImage,
  heroImageAlt = HERO_DEFAULTS[H_02].heroImageAlt,
  className,
}) => {
  return (
    <section className={`${styles.sectionWrapper} ${className || ""}`}>
      {/* Main Hero Section */}
      <div className={styles.h2container}>
        <div className={styles.heroContent}>
          {/* Left Content */}
          <div className={styles.leftContent}>
            {/* Text Content */}
            <div className={styles.textContent}>
              <h1 className={styles.heading}>{heading}</h1>
              <p className={styles.description}>{description}</p>
            </div>

            {/* CTA Buttons */}
            <div className={styles.buttonWrapper}>
              {primaryButtonText && primaryButtonUrl && (
                <LinkButton
                  styleType="no-style"
                  href={primaryButtonUrl}
                  className={styles.primaryBtn}
                >
                  {primaryButtonText}
                </LinkButton>
              )}
              {secondaryButtonText && secondaryButtonUrl && (
                <LinkButton
                  styleType="no-style"
                  href={secondaryButtonUrl}
                  className={styles.primaryOutlineBtn}
                >
                  {secondaryButtonText}
                </LinkButton>
              )}
            </div>
          </div>

          {/* Right Image */}
          <div className={styles.rightImage}>
            <Multimedia
              type="image"
              src={heroImage}
              alt={heroImageAlt}
              className={styles.h07Image}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default H02;
